import { render, staticRenderFns } from "./RefundForm.vue?vue&type=template&id=64bd9c47&scoped=true&"
import script from "./RefundForm.vue?vue&type=script&lang=js&"
export * from "./RefundForm.vue?vue&type=script&lang=js&"
import style0 from "./RefundForm.vue?vue&type=style&index=0&id=64bd9c47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd9c47",
  null
  
)

export default component.exports